import React from "react";
import { Typography } from "@mui/material";

const SessionCard = ({ analyticsData, themeBg }) => {
  return (
    <div
      style={{
        backgroundColor: themeBg || "#353535", // Use themeBg prop if provided, or fall back to default
        borderRadius: "12px",
        padding: "8px 10px 8px 15px",
        paddingLeft: "20px",
        color: "#FFFFFF",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        position: "relative",
      }}
    >
      {/* Sessions Section - reduced margins and spacing */}
      <Typography
        variant="h6"
        style={{ fontWeight: "bold", marginBottom: "5px", fontSize: "15px" }}
      >
        Sessions
      </Typography>
      <Typography variant="body1" style={{ marginBottom: "3px", fontSize: "14px" }}>
        Total: {analyticsData?.sessions?.total || "N/A"}
      </Typography>
      <Typography variant="body1" style={{ marginBottom: "10px", fontSize: "14px" }}>
        Bot: {analyticsData?.sessions?.bot || "N/A"}
      </Typography>

      {/* Active Time Section - reduced margins */}
      <Typography
        variant="h6"
        style={{ fontWeight: "bold", marginBottom: "5px", fontSize: "15px" }}
      >
        Active Time
      </Typography>
      <div style={{ display: "flex", alignItems: "center", marginBottom: "3px" }}>
        <Typography variant="caption" style={{ fontSize: "11px", opacity: 0.8, marginRight: "8px" }}>
          Avg. Active Time:
        </Typography>
        <Typography variant="body1" style={{ fontSize: "14px", fontWeight: "bold" }}>
          {analyticsData?.engagement?.activeTime || "N/A"} 
          <span style={{ fontSize: "12px", marginLeft: "2px" }}>mins</span>
        </Typography>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="caption" style={{ fontSize: "11px", opacity: 0.8, marginRight: "8px" }}>
          Total Time Spent:
        </Typography>
        <Typography variant="body1" style={{ fontSize: "14px", fontWeight: "bold" }}>
          {analyticsData?.engagement?.totalTime || "N/A"} 
          <span style={{ fontSize: "12px", marginLeft: "2px" }}>mins</span>
        </Typography>
      </div>

      {/* Right-Side Cards Inside Left Card - adjusted to reduce height */}
      <div
        style={{
          position: "absolute",
          top: "0",
          right: "0",
          width: "45%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "5px", // Reduced gap
        }}
      >
        {/* Top Card - more compact */}
        <div
          style={{
            flex: 1,
            backgroundColor: "#535353",
            borderRadius: "12px",
            padding: "8px",
            color: "#FFFFFF",
            position: "relative",
            zIndex: 1,
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h12"
            style={{ fontWeight: "bold", marginBottom: "5px", fontSize: "13px" }}
          >
            Avg. Scroll depth
          </Typography>
          <Typography
            variant="body1"
            style={{
              fontSize: "24px", // Slightly reduced font size
              fontWeight: "bold",
            }}
          >
            {analyticsData?.engagement?.scrollDepth || "N/A"}%
          </Typography>
        </div>

        {/* Bottom Card - more compact with less overlap */}
        <div
          style={{
            flex: 1,
            backgroundColor: "#8B8B8B",
            borderRadius: "12px",
            padding: "8px",
            color: "#FFFFFF",
            position: "relative",
            zIndex: 2,
            marginTop: "-20px", // Reduced overlap
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h8"
            style={{ fontWeight: "bold", marginBottom: "5px", fontSize: "13px" }}
          >
            Pages / Session
          </Typography>
          <Typography
            variant="body1"
            style={{
              fontSize: "24px", // Slightly reduced font size
              fontWeight: "bold",
            }}
          >
            {Number(analyticsData?.pages?.averagePerSession)?.toFixed(2) ||
              "N/A"}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default SessionCard;
